module.exports = "https://web-assets.ifttt.com/packs/media/magick_account/arrows-412ceab8.png";